import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import GameImage from '@/pages/home/components/GameImage';
import { getCountryFlag } from '@/pages/home/_config/countries';
import '@/pages/intelligence/components/TableComponents/components/GameInfocont/index.scss';
import './index.scss';
import TipOne from '@/pages/intelligence/assets/svg/tipicon/tip-one.svg';
import TipTwo from '@/pages/intelligence/assets/svg/tipicon/tip-two.svg';
import TipThree from '@/pages/intelligence/assets/svg/tipicon/tip-three.svg';
import Databrain from '@/pages/intelligence/assets/svg/dataSource/databarin.svg';
import type { IBaseProps } from '@/pages/intelligence/types/common';
import TextBubblesDbi from '@/pages/intelligence/components/TextBubblesDbi';
import TextBubbles from '@/pages/home/components/TextBubbles';
import { MINI_GAME_ENTITY_TYPE } from '@intelligence/v3/pages/ReusePages/CasualMiniGameRankings/config';

const RANK_ICONS = [TipOne, TipTwo, TipThree];

interface IStoreRanksTopRankGameProps extends IBaseProps {
  // 游戏类型 mobile pc console
  entityType: 'mobile' | 'pc' | 'console' | 'minigame';
  // 游戏名称
  name: string;
  // 游戏icon
  cover: string;
  // 游戏rank排名
  rank: number;
  // 游戏市场（展示国旗需要用到）
  market: string;
  // 游戏publisher
  publisher: string;
  // 游戏平台
  platforms?: string[];
  // 是否展示游戏平台icons
  isShowPlatformIcon?: boolean;
  // 是否展示DataBrain的icon
  isShowDataBrainIcon?: boolean;
  // 点击icon、name的回调
  onClick?: (e: React.SyntheticEvent<HTMLElement>) => void;
}

// gameType mobile pc console
const StoreRanksTopRankGame: React.FC<IStoreRanksTopRankGameProps> = (
  props,
) => {
  const {
    entityType,
    name,
    cover,
    rank = Number.NaN,
    market,
    publisher,
    platforms = [],
    isShowPlatformIcon = false,
    isShowDataBrainIcon = false,
    isShowMarketIcon = true,
    onClick,
    gameNameTag,
  } = props;

  const handleClick = (e: React.SyntheticEvent<HTMLElement>) => {
    e?.stopPropagation();
    e?.preventDefault();
    onClick?.(e);
  };

  return (
    <div
      className={`dbi-gameinfocont dbi-gameinfocont--${entityType} dbi-store-rank-top__game-info`}
    >
      {/* rank排名数值 */}
      <div className="dbi-gameinfocont-rank">
        {rank > 0 && rank <= 3 ? (
          <img src={RANK_ICONS[rank - 1]} alt="" />
        ) : (
          <span>{rank}</span>
        )}
      </div>
      <div className="dbi-gameinfocont-wrap">
        {/* 游戏icon */}
        <div className="dbi-gameinfocont-img" onClick={handleClick}>
          <GameImage entityType={entityType} src={cover} />
        </div>

        <div className="dbi-gameinfocont-cont">
          <div className="dbi-gameinfocont-title">
            {/* 游戏name */}
            <span onClick={handleClick}>
              {entityType === MINI_GAME_ENTITY_TYPE ? (
                <TextBubblesDbi text={name} gameNameTag={gameNameTag} />
              ) : (
                <TextBubbles text={name} />
              )}
            </span>
            {/* 是否为DataBrain的icon */}
            {isShowDataBrainIcon && <img src={Databrain} alt="" />}
          </div>
          <div className="dbi-gameinfocont-text">
            {isShowMarketIcon && (<img src={getCountryFlag(market)} alt="" />)}

            {entityType === MINI_GAME_ENTITY_TYPE ? (
              <TextBubblesDbi text={publisher} isSubText={true} />
            ) : (
              <div className="dbi-gameinfocont-subtextlist">
                <span>{publisher || '-'}</span>
              </div>
            )}
          </div>
          {/* 游戏平台icons */}
          {isShowPlatformIcon && platforms?.length > 0 && (
            <div className="dbi-gameinfocont-icon">
              {platforms.map((platform) => (
                <SvgIcon key={platform} type={platform} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoreRanksTopRankGame;
